import { lazy } from 'react';

export const ConnectWalletRegistration = lazy(() => import('./ConnectWalletRegistration.component'));
